import { concat } from 'lodash/array'
import remove from 'lodash/remove'
import uniq from 'lodash/uniq'
import qs from 'qs'

import * as types from '../constants/ActionTypes'

export const nlt = function nlt(state = {}, action) {
  switch (action.type) {
    case types.GET_NLT_CANONE_PERSONALIZZATO_V1:
      const canoniPersonalizzati =
        action.payload.data.result.nlt_proxy_result || []
      const isCanoneCodeResponse =
        Array.isArray(canoniPersonalizzati) && canoniPersonalizzati.length > 0

      const _canoniPersonalizzati = canoniPersonalizzati.map(canone => {
        canone.custom = 1
        return canone
      })

      const _canoniIndexed = _canoniPersonalizzati.reduce(
        (accumulator, canone) => {
          accumulator[canone.id_canone] = canone
          return accumulator
        },
        {}
      )

      const _anticipoNumeroMensilita = _canoniPersonalizzati.reduce(
        (accumulator, canone) => {
          accumulator[`${canone.anticipo}_${canone.numero_mensilita}`] =
            canone.id_canone
          return accumulator
        },
        {}
      )

      const partialCouponOrCanonePersonalizzatoState = {}
      if (isCanoneCodeResponse) {
        // costruisco state per canone personalizzato
        partialCouponOrCanonePersonalizzatoState.canonePersonalizzato =
          state.couponOrCanonePersonalizzato
        partialCouponOrCanonePersonalizzatoState.minicartLabelCanonePersonalizzato =
          'Codice preventivo su misura'
      } else {
        // costruisco state per coupon promozionale
        partialCouponOrCanonePersonalizzatoState.codiceCoupon =
          state.couponOrCanonePersonalizzato
        partialCouponOrCanonePersonalizzatoState.minicartLabelCoupon =
          action.payload.data.result.minicart_label || 'Coupon'
      }

      return {
        ...state,
        anticipoNumeroMensilita: {
          ...state.anticipoNumeroMensilita,
          ..._anticipoNumeroMensilita,
        },
        canoniIndexed: { ...state.canoniIndexed, ..._canoniIndexed },
        defaultCanone: isCanoneCodeResponse ? {} : state.defaultCanone,
        selectedCanone: isCanoneCodeResponse
          ? canoniPersonalizzati[0]
          : state.selectedCanone,
        ...partialCouponOrCanonePersonalizzatoState,
      }
    case types.GET_CMS_CANONI_V4:
      const canoni = concat(state.canoni, action.payload.data.result)
      const idSelectedCanone = qs.parse(
        window.location.search.substring(1)
      ).id_canone
      const anticipoNumeroMensilita = canoni.reduce((accumulator, canone) => {
        accumulator[`${canone.anticipo}_${canone.numero_mensilita}`] =
          canone.id_canone
        return accumulator
      }, {})

      const canoniIndexed = canoni.reduce((accumulator, canone) => {
        accumulator[canone.id_canone] = canone
        return accumulator
      }, {})

      const defaultCanone = canoni.reduce((accumulator, canone) => {
        const isDefaultCanone = canone.default
        return isDefaultCanone ? canone : accumulator
      }, {})

      const anticipi = uniq(canoni.map(canone => canone.anticipo))
      const numeroMensilita = uniq(
        canoni.map(canone => canone.numero_mensilita)
      )

      const selectedDefaultCanone = canoni.filter(
        // eslint-disable-next-line
        canone => canone.id_canone == idSelectedCanone
      )

      const selectedCanone = idSelectedCanone
        ? selectedDefaultCanone[0]
        : defaultCanone

      return {
        ...state,
        canoni,
        anticipi,
        anticipoNumeroMensilita,
        canoniIndexed,
        defaultCanone,
        numeroMensilita,
        selectedCanone,
      }
    case types.SCEGLI_CANONE_SET_ANTICIPO:
    case types.SCEGLI_CANONE_SET_CANONE:
    case types.SCEGLI_CANONE_SET_NUMERO_MENSILITA:
      return { ...state, ...action.payload }
    case types.GET_NLT_SERVIZI_PLUS_V1:
      const serviziPlusByIdTipologia = action.payload.data.result.reduce(
        (accumulator, servizioPlus) => {
          accumulator[servizioPlus.id_servizio] = servizioPlus
          return accumulator
        },
        {}
      )

      return {
        ...state,
        serviziPlus: action.payload.data.result,
        serviziPlusByIdTipologia,
      }
    case types.GET_NLT_TABELLE_DOMINIO_CARICA_PRIVATA_V1:
      const caricaPrivata = action.payload.data.result.map(element => ({
        label: element.descrizione,
        value: element.codice,
      }))
      return { ...state, caricaPrivata }
    case types.GET_NLT_TABELLE_DOMINIO_OCCUPAZIONE_V1:
      const occupazione = action.payload.data.result.map(element => ({
        label: element.descrizione,
        value: element.codice,
      }))
      return { ...state, occupazione }
    case types.GET_NLT_TABELLE_DOMINIO_SITUAZIONE_ABITATIVA_V1:
      const situazioneAbitativa = action.payload.data.result.map(element => ({
        label: element.descrizione,
        value: element.codice,
      }))
      return { ...state, situazioneAbitativa }
    case types.GET_NLT_TABELLE_DOMINIO_SITUAZIONE_LAVORATIVA_V1:
      const situazioneLavorativa = action.payload.data.result.map(element => ({
        label: element.descrizione,
        value: element.codice,
      }))
      return { ...state, situazioneLavorativa }
    case types.GET_NLT_TABELLE_DOMINIO_STATO_CIVILE_V1:
      const statoCivile = action.payload.data.result.map(element => ({
        label: element.descrizione,
        value: element.codice,
      }))
      return { ...state, statoCivile }
    case types.GET_NLT_TABELLE_DOMINIO_TIPOLOGIA_CONTRATTO_V1:
      const tipoContratto = action.payload.data.result.map(element => ({
        label: element.descrizione,
        value: element.codice,
      }))
      return { ...state, tipoContratto }
    case types.GET_NLT_TABELLE_DOMINIO_SETTORE_V1:
      const settore = action.payload.data.result.map(element => ({
        label: element.descrizione,
        value: element.codice,
      }))
      return { ...state, settore }
    case types.GET_NLT_TABELLE_DOMINIO_RUOLO_PA_V1:
      const ruoloPa = action.payload.data.result.map(element => ({
        label: element.descrizione,
        value: element.codice,
      }))
      return { ...state, ruoloPa }
    case types.SERVIZI_PLUS_SELECTED_SERVIZIO:
      const prevSelected = state.serviziPlusSelected
      prevSelected.push(action.payload.id_servizio)
      return {
        ...state,
        serviziPlusCosto:
          state.serviziPlusCosto + Number(action.payload.canone_extra),
        serviziPlusSelected: uniq(prevSelected),
      }
    case types.SERVIZI_PLUS_UNSELECTED_SERVIZIO:
      const prevSelectedd = state.serviziPlusSelected
      remove(prevSelectedd, element => element === action.payload.id_servizio)
      return {
        ...state,
        serviziPlusCosto:
          state.serviziPlusCosto - Number(action.payload.canone_extra),
        serviziPlusSelected: uniq(prevSelectedd),
      }
    case types.SERVIZI_PLUS_UNSELECT_ALL:
      return { ...state, serviziPlusCosto: 0, serviziPlusSelected: [] }
    case types.NLT_UPDATE_DATI:
      const currentDati = state.dati
      const newDati = { ...currentDati, ...action.payload }
      return { ...state, dati: newDati }
    case types.NLT_UPDATE_PAYMENT_METHOD:
      return { ...state, stripePaymentMethod: action.payload }
    case types.POST_TRANSAZIONI_CREATE_SEPA_INTENT:
      return { ...state, stripeSepaIntent: action.payload.data.result }
    case types.GET_NLT_DOCUMENTI_V1:
      return { ...state, documenti_necessari: action.payload.data.result }
    case types.NLT_FILE_UPLOAD_DROPPED:
      const dropzone = [].concat([], state.dropzone, action.payload.dropzone)
      const newState = { ...state, dropzone }
      return newState
    case types.NLT_FILE_UPLOAD_REMOVED:
      const removedState = { ...state }
      removedState.dropzone.splice(parseInt(action.payload, 10), 1)
      return removedState
    case types.STORE_RESTORE_CALLBACK:
      /**
       * BRUM-5147
       * consenso_base diventa
       * consenso_base_privacy_arval
       */
      const _nlt = action.payload.data.result.frontend.nlt
      if ('dati' in _nlt) {
        if ('consenso_base' in _nlt.dati) {
          _nlt.dati.consenso_base_privacy_arval = _nlt.dati.consenso_base
        }
      }

      // altrimenti ci troviamo dentro oggetti js serializzati senza metodi
      _nlt.dropzone = []

      return { ...state, ..._nlt }
    case types.SCEGLI_CANONE_SET_CANONE_PERSONALIZZATO:
      return {
        ...state,
        couponOrCanonePersonalizzato: action.payload,
        minicartLabel: null,
      }
    case types.GET_FIRMA_STATUS:
      const firma = {
        status: action.payload.data.result,
      }
      return { ...state, firma }
    default:
      return state
  }
}
